export default __webpack_public_path__ + "static/media/car.ae61da4f.svg";